import { MenuItem, MenuList } from '@mui/material';
import { Stack } from '@mui/material';
import React from 'react';
var JobCardMoreAction = function (_ref) {
    var onClose = _ref.onClose, menus = _ref.menus;
    return /*#__PURE__*/ React.createElement(Stack, {
        width: '270px'
    }, /*#__PURE__*/ React.createElement(MenuList, {
        sx: {
            width: '100%',
            padding: 0
        }
    }, menus === null || menus === void 0 ? void 0 : menus.map(function (item, index) {
        return /*#__PURE__*/ React.createElement(MenuItem, {
            id: item.DisplayName,
            dense: true,
            key: index,
            sx: {
                width: '100%',
                height: '42px',
                borderBottom: index === menus.length - 1 ? "none" : '1px solid ',
                borderColor: 'secondary.200',
                fontWeight: 'medium'
            },
            onClick: function (event) {
                onClose(item);
            }
        }, item.DisplayName);
    })));
};
export default JobCardMoreAction;
